export const API_BASE_URL = (
  process.env.REACT_APP_BACKEND_URL ||
  process.env.REACT_APP_API_URL ||
  "https://uniformnx-com.onrender.com"
).replace(/\/$/, "");
